export const AccountOpeningSteps_Handle = 'AccountOpeningSteps_Handle';

export const accountOpeningStepsHandle = (data) =>({
    type: AccountOpeningSteps_Handle,
    data
});



// WEBPACK FOOTER //
// ./src/views/AccountOpeningSteps/state/action.js